document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelector(".learn-videos-columns__grid .video")){
        document.querySelectorAll(".learn-videos-columns__grid .video").forEach( item => {
            const button = item.querySelector(".video__content-btns-image");
            button.addEventListener("click", function(){
                const video = document.createElement('div');
                const id = item.dataset.video;
                video.classList.add('video-holder-main');
                video.innerHTML = `<iframe class="video__video" width="100%" height="100%" src="https://www.youtube.com/embed/${id}?rel=0&controls=1&showinfo=0&loop=1" rel="0" allow="autoplay" allowfullscreen frameborder="0"></iframe>`;
                button.style.display = 'none'
                item.querySelector('.video__content-holder').appendChild(video);
                setTimeout(function(){
                    item.querySelector('iframe').src += "&autoplay=1";
                }, 500);
            });
        })
    }      
});
  